import { TooltipHost } from "@fluentui/react";
import { CustomCell, CustomRenderer, GridCellKind } from "@glideapps/glide-data-grid";
import { StatusIcon } from "../../Components/CargarPorFormulario/ImportAct";

export interface ValidaCellProps {
  readonly kind: "valida-cell";
  readonly id: string;
  readonly valida: number;
  readonly descripcionError?: string;
}

export type ValidaCell = CustomCell<ValidaCellProps>;

export const ValidaCellRenderer: CustomRenderer<ValidaCell> = {
  kind: GridCellKind.Custom,

  isMatch: (cell): cell is ValidaCell =>
    cell.kind === GridCellKind.Custom && (cell.data as any).kind === "valida-cell",

  draw: (args, cell) => {
    const { ctx, rect, theme } = args;
    const { valida } = cell.data;

    if (valida === 0) {

        // signo de "X" en blanco
        ctx.strokeStyle = "red";
        ctx.lineWidth = 2.5;
        ctx.beginPath();
        ctx.moveTo(rect.x + rect.width / 2 - 7, rect.y + rect.height / 2 - 7);
        ctx.lineTo(rect.x + rect.width / 2 + 7, rect.y + rect.height / 2 + 7);
        ctx.moveTo(rect.x + rect.width / 2 + 7, rect.y + rect.height / 2 - 7);
        ctx.lineTo(rect.x + rect.width / 2 - 7, rect.y + rect.height / 2 + 7);
        ctx.stroke();

        return true;
    }

    if (valida === 1) {
      const cx = rect.x + rect.width / 2;
      const cy = rect.y + rect.height / 2;

      ctx.save();
      ctx.strokeStyle = "green";
      ctx.lineWidth = 3;
      ctx.lineCap = "round";

      ctx.beginPath();
      ctx.moveTo(cx - 8, cy);
      ctx.lineTo(cx - 2, cy + 8);
      ctx.lineTo(cx + 10, cy - 8);

      ctx.stroke();
      ctx.restore();
    }

    if (valida === 2) {
      const borderColor = "#ffffff";
      const iconColor = "#ffffff";
      const fillColor = "yellow";
      const BASE_RADIUS = 12;

      const cx = rect.x + rect.width / 2;
      const cy = rect.y + rect.height / 2;

      ctx.save();
      ctx.beginPath();
      ctx.arc(cx, cy, BASE_RADIUS, 0, Math.PI * 2);
      ctx.closePath();

      ctx.fillStyle = fillColor;
      ctx.fill();

      ctx.lineWidth = 1.5;
      ctx.strokeStyle = borderColor;
      ctx.stroke();

      const fontSize = Math.round(BASE_RADIUS * 1.8);
      ctx.font = `bold ${fontSize}px sans-serif`;
      ctx.fillStyle = iconColor;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      ctx.fillText("!", cx, cy);

      ctx.restore();
    }

    return true;
  },

  provideEditor: () => {
    return p => {
      const { data } = p.value;

      return (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <TooltipHost content={data.descripcionError}>
            <StatusIcon valida={data.valida} />
          </TooltipHost>
        </div>
      );
    };
  },
};
